export const MARK_UP_TYPE_BY_SLUG = {
  amount: {
    id: 1,
    label: 'markupTypeAmount'
  },

  percentage: {
    id: 2,
    label: 'markupTypePercentage'
  }
};

export const MARK_UP_TYPE_LABEL = {
  AMOUNT: 'amount',
  PERCENTAGE: 'percentage'
};

export const MARK_UP_TYPE_BY_ID = {
  1: 'amount',
  2: 'percentage'
};
